var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"loading":_vm.loading,"flat":""}},[_c('MiniEquity',{attrs:{"data":_vm.data,"source":"trades"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }